import { TextCell } from "@/components/2/text-cell/text-cell";

type AircallNumberIdCellProps = {
  id: number | null;
  onUpdate?: (value: string) => void;
};

export const AircallNumberIdCell = ({ id, onUpdate }: AircallNumberIdCellProps) => {
  return (
    <TextCell
      value={id}
      onSave={onUpdate ? value => onUpdate(value) : undefined}
      type="number"
      placeholder="Number ID"
    />
  );
};
